import React from 'react';
import { Flex, Text, Divider } from '@tonic-ui/react';

import { supportedLocales } from '../locales/supportedLocales';

const LangToggle = ({ globalEventDistributor }) => {
  const storedLocale = localStorage.getItem('C1C_locale');
  const currentLocale =
    storedLocale && supportedLocales.includes(storedLocale) ? storedLocale : 'en';

  const notCurrentLangStyles = {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: '#95b7fc',
    '&:hover': {
      textDecoration: 'none',
    },
  };

  const onLangToggle = (lang) => {
    localStorage.setItem('C1C_locale', lang);
    globalEventDistributor.dispatch({ type: 'SET_LOCALE', locale: lang });
  };

  return (
    <Flex>
      <Text
        css={currentLocale !== 'en' ? { ...notCurrentLangStyles } : {}}
        tabIndex={0}
        onClick={() => onLangToggle('en')}
        onKeyDown={(e) => {
          if (e?.key === 'Enter') onLangToggle('en');
        }}
      >
        English
      </Text>
      <Text
        marginLeft="10px"
        marginRight="10px"
        css={currentLocale !== 'ja' ? { ...notCurrentLangStyles } : {}}
        tabIndex={0}
        onClick={() => onLangToggle('ja')}
        onKeyDown={(e) => {
          if (e?.key === 'Enter') onLangToggle('ja');
        }}
      >
        日本語
      </Text>
      <Divider orientation="vertical" />
    </Flex>
  );
};

export default LangToggle;
